import { createAction } from '@reduxjs/toolkit'

import type { InvoiceDownloadPayload, SubscriptionState } from './types'

export const SetSubscriptionAction =
  createAction<SubscriptionState>('SUBSCRIPTION_SET')

export const SubscriptionActions = {
  fetch: createAction('SUBSCRIPTION_FETCH'),
  braintreeCancel: createAction('SUBSCRIPTION_BRAINTREE_CANCEL'),
  downloadInvoice: createAction<InvoiceDownloadPayload>(
    'SUBSCRIPTION_DOWNLOAD_INVOICE'
  ),
  requestBillingPortal: createAction('SUBSCRIPTION_REQUEST_BILLING_PORTAL'),
}
